import Amplify from '@aws-amplify/core'
import environment from '_environments'

// Sentry and the session tools live in dependency-free modules so the new
// shell can start them without this barrel's Amplify and Redux imports
// (MAM-1015). Re-exported so the legacy entry's imports stay as they were.
export { configureSentry } from '@/services/sentry'
export { configureAnalytics } from '@/services/analytics'
export * from '@/services/user.service'
export * from '@/services/icons'

export function configureAmplify() {
  const { aws } = environment

  const config = {
    Auth: {
      mandatorySignIn: true,
      region: aws.region,
      userPoolId: aws.userPoolId,
      identityPoolId: aws.identityPoolId,
      userPoolWebClientId: aws.userPoolWebClientId,
    },
    API: {
      endpoints: [
        {
          name: 'login',
          endpoint: aws.awsApiAmplifyUrl,
          region: aws.region,
        },
        {
          name: 'my-asset-map-api',
          endpoint: aws.awsApiAmplifyUrl2,
          region: aws.region,
          authorizationType: 'AMAZON_COGNITO_USER_POOLS',
        },
      ],
    },
  }

  Amplify.configure(config)
}
